/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiVendorVendorAuctionGetStatusVendorAllGet$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiVendorVendorAuctionGetStatusVendorAllGet(http: HttpClient, rootUrl: string, params?: ApiVendorVendorAuctionGetStatusVendorAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, apiVendorVendorAuctionGetStatusVendorAllGet.PATH, 'get');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

apiVendorVendorAuctionGetStatusVendorAllGet.PATH = '/api/vendor/vendor-auction/GetStatusVendorAll';
